<template>
  <div>
    <v-dialog v-model="openDialog" max-width="1200px" persistent scrollable>
      <template v-slot:activator="{ on }">
        <mf-button label="Selecionar ofertas" @click="openDialog = true" />
      </template>
      <v-card>
        <v-card-title>
          <span class="mf-h6 primary-text">Selecionar ofertas</span>
        </v-card-title>
        <v-card-text>
          <select-campaigns-offer-sales v-model="selectedOffers" :status="status" />
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Confirmar',
              action: save,
              isVisible: true,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-chip-group v-if="loadingInitialState" column active-class="primary--text">
      <v-chip v-for="(offer, index) in initialValue" :key="`${index}-loading`" class="disabled-chip" small :ripple="false">
        <v-progress-circular indeterminate color="primary" size="15" />
      </v-chip>
    </v-chip-group>

    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(offer, index) in selectedOffers"
        :key="`chip-${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeSelectedOffer(index)"
      >
        <span>{{ offer.name }}</span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import SelectCampaignsOfferSales from '@/components/select-campaigns-modal/SelectCampaignsOfferSales.vue'
import { QUERY_LIST_SALES_CAMPAIGNS } from '@/modules/campanhas/gestao-ofertas-v2/graphql'

export default {
  components: { SelectCampaignsOfferSales },
  props: {
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    currentIndex: Number,
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      selectedOffers: [],
      loadingInitialState: false,
    }
  },
  computed: {
    query() {
      return QUERY_LIST_SALES_CAMPAIGNS
    },
  },
  async mounted() {
    await this.setInitialState()
    this.validate()
  },
  methods: {
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.selectedOffers && this.selectedOffers.length)
    },
    async setInitialState() {
      if (this.initialValue && this.initialValue.length > 0) {
        await this.getOffers(this.initialValue)
      } else {
        this.selectedOffers = []
      }
    },
    closeDialog() {
      this.openDialog = false
    },
    save() {
      this.$emit('input', { currentValue: this.selectedOffers.map(({ _id }) => _id), currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
      this.closeDialog()
    },
    removeSelectedOffer(index) {
      this.selectedOffers.splice(index, 1)
    },
    async getOffers(offerIds) {
      const queryVariables = {
        offerIds,
        status: this.status.map((status) => status.toLowerCase()),
        includeAuto: false,
      }
      try {
        this.loadingInitialState = true
        const variables = { ...queryVariables }
        const { data } = await this.$apollo.query({
          query: this.query,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: this.$microservicesUrls['sales'],
          },
        })
        this.selectedOffers = data.offerSchedules.offerSchedules
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
      this.loadingInitialState = false
    },
  },
}
</script>
